import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDividerModule } from '@angular/material/divider';

@NgModule({
  declarations: [
    FooterComponent,
  ],
  imports: [
    CommonModule,

    MatDividerModule,
    MatToolbarModule,
    MatIconModule,
    MatMenuModule
  ],
  exports: [
    FooterComponent
  ]
})
export class FooterModule { }
